import type { TOC } from '@ember/component/template-only';

import styles from './group.module.css';

interface SettingsCurrencyConversionCurrencyPickerGroupSignature {
  Args: {
    label: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const SettingsCurrencyConversionCurrencyPickerGroup = <template>
  <div class={{styles.group}} ...attributes>
    <span class="text-300--bold text-neutral-emphasis px-300 pt-400 pb-200">
      {{@label}}
    </span>

    {{yield}}
  </div>
</template> satisfies TOC<SettingsCurrencyConversionCurrencyPickerGroupSignature>;

export default SettingsCurrencyConversionCurrencyPickerGroup;
